<template>
    <div class="footer-wrapper">
        <div class="db-footer">
            <div class="footer-left">
                <div class="rights">Copyright © 汕头市玛利宝包装有限公司,2011.All Rights Reserved
                    <a href="https://beian.miit.gov.cn/" class="record" target="_blank">粤ICP备20007183号-1</a>
                </div>
            </div>
            <div class="footer-right">
                <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44051102000998" target="_blank">
                    <el-image :src="require('@/assets/police.png')"
                        style="width: 1.5rem;height: 1.5rem;margin: .3125rem .5rem 0 0;"></el-image>
                </a>
                <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44051102000998" target="_blank">
                    <span class="record">粤公网安备44051102000998号</span>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {}
    },

    methods: {

    }
}
</script>

<style scoped lang="less">
.footer-wrapper {
    display: flex;
    width: 61.875rem;
    height: 2.0625rem;
    margin: 0 auto;
    background-color: #707070;
    opacity: 1;
    position: relative;
}

.db-footer {
    display: flex;
    color: #fcfcfc;
    font-size: .8125rem;
}

.footer-left {
    margin-left: 1.25rem;
    display: flex;
    align-items: center;
    //position: absolute;

    .record:hover {
        color: #ff0000;
    }
}

.footer-right {
    position: absolute;
    right: 1.25rem;
    display: flex;
    align-items: center;

    .record:hover {
        color: #ff0000;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/public/Footer.vue